<template>

    <div class="container">

        <app-head title="Checkout" />

        <div class="my-4">
            <inertia-link :href="route('cart.index')">
                <i class="bi bi-arrow-left"></i>
                {{ __('Zurück zum Warenkorb') }}
            </inertia-link>
        </div>

        <div class="my-4">
            <h1>{{ __('Bestellung überprüfen') }}</h1>
        </div>

        <updated-cart-items :updated-cart-items="updatedCartItems" />


        <form @submit.prevent="form.post(route('checkout.submit'))">

            <div class="row">
                <div class="col-sm-8">

                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="row row-cols-1 row-cols-md-2 g-4 mb-4">
                                <div class="col">
                                    <h4 class="card-title">
                                        {{ __('Rechnungsadresse') }}
                                    </h4>
                                    <div v-if="form.billing_address" class="mb-4">
                                        <div v-html="form.billing_address.formatted_output"></div>
                                    </div>
                                    <inertia-link :href="route('addresses.index', {action: 'select_billing_address'})" class="btn btn-outline-primary">
                                        {{ __('Ändern') }}
                                    </inertia-link>
                                </div>
                                <div class="col">
                                    <h4 class="card-title">
                                        {{ __('Lieferadresse') }}
                                    </h4>
                                    <div v-if="form.delivery_address" class="mb-4">
                                        <div v-html="form.delivery_address.formatted_output"></div>
                                    </div>
                                    <div v-else class="mb-4">
                                        {{ __('Die Lieferadresse entspricht der Rechnungsadresse.') }}
                                    </div>
                                    <inertia-link :href="route('addresses.index', {action: 'select_delivery_address'})" class="btn btn-outline-primary" data-bs-toggle="modal@todo" data-bs-target="#addressModal">
                                        {{ __('Ändern') }}
                                    </inertia-link>
                                    <button type="button" class="btn btn-outline-danger" @click="removeDeliveryAddress()" v-if="form.delivery_address">
                                        {{ __('Entfernen') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="mb-4">

                        <h3 class="mb-4">
                            {{ __('Ihre Produkte') }}
                        </h3>

                        <checkout-items
                            v-for="(group, supplierId) in form.cart_items_by_supplier"
                            :group="group"
                            :key="supplierId"
                            @update-checkout="updateCheckout"
                            />

                    </div>

                </div>
                <div class="col-sm-4">
                    <div class="card bg-light border-0 sticky-top">
                        <div class="card-body">
                            <h4 class="card-title">{{ __('Bestellungsübersicht') }}</h4>
                            <p class="card-text">
                                {{ __(':number Produkt(e)', {number: productsCount}) }}
                            </p>
                            <table class="table">
                                <tbody>
                                    <tr>
                                        <th class="">{{ __('Nettosumme') }}</th>
                                        <td class="text-end">
                                            {{ subtotal | localizeAmount }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th class="">{{ __('zzgl. Versand gesamt') }}</th>
                                        <td class="text-end">
                                            {{ delivery | localizeAmount }}
                                        </td>
                                    </tr>
                                    <tr v-for="group in cartItemsBySupplier">
                                        <th class="fw-normal small">&nbsp;&nbsp;&nbsp;{{ group.supplier.short_name }}</th>
                                        <td class="text-end small">
                                            {{ group.delivery | localizeAmount }}
                                        </td>
                                    </tr>
                                    <tr v-for="(taxAmount, taxRate) in cummulatedTaxAmounts">
                                        <th class="fw-normal">{{ __('MwSt. :rate', {rate: $options.filters.localizePercent(taxRate)}) }}</th>
                                        <td class="text-end">
                                            {{ taxAmount | localizeAmount(2) }}
                                        </td>
                                    </tr>
                                    <tr class="">
                                        <th class="fw-bold">{{ __('Gesamtsumme inkl. MwSt.') }}</th>
                                        <td class="text-end fw-bold">
                                            {{ total | localizeAmount(2) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="my-4 small">
                                <div class="d-flex align-items-center">
                                    <div>
                                        <i class="bi bi-info-circle fs-4"></i>
                                    </div>
                                    <div class="ms-2">
                                        {{ __('Versandkosten können bei bestimmten Produkten (bspw. Sperrgut oder Briefmarken) in der Endabrechnung abweichen') }}
                                    </div>
                                </div>
                            </div>

                            <template v-if="$page.props.app.theme == 'dentalink'">
                                <stripe-payment-element :form="form" />
                            </template>

                            <button 
                                type="submit" 
                                class="btn btn-lg fs-5 btn-primary fw-bold text-white w-100" 
                                :disabled="form.processing"
                                >
                                {{ __('Jetzt kaufen') }}
                            </button>

                        </div>
                    </div>
                </div>
            </div>

        </form>

        <!--@todo-->
        <div class="modal fade" id="addressModal" tabindex="-1" aria-labelledby="addressModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addressModalLabel">{{ __('Adressen') }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="list-group">
                            <div class="list-group-item list-group-item-action active" aria-current="true">
                                <div class="d-flex w-100 justify-content-between">
                                    <h5 class="mb-1">List group item heading</h5>
                                    <small>3 days ago</small>
                                </div>
                                <p class="mb-1">Some placeholder content in a paragraph.</p>
                                <small>And some small print.</small>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">abbrechen</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import CheckoutItems from './CheckoutItems';
    import RadiosInput from '@/shared/Inputs/RadiosInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';

    import StripePaymentElement from '@/shared/StripePaymentElement';

    import UpdatedCartItems from './../Cart/UpdatedCartItems';


    export default {
        props: [
            'tax',
            'subtotal',
            'total',
            'delivery',
            'billingAddress',
            'deliveryAddress',
            'productsCount',
            'cartItemsBySupplier',
            'cummulatedTaxAmounts',
            'supplierId',
            'updatedCartItems',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    cart_items_by_supplier: this.cartItemsBySupplier,
                    billing_address: this.billingAddress,
                    billing_address_id: this.billingAddress ? this.billingAddress.id : null,
                    delivery_address: this.deliveryAddress,
                    delivery_address_id: this.deliveryAddress ? this.deliveryAddress.id : null,
                    notes: null,
                    supplier_id: this.supplierId,
                }),
            }
        },
        components: {
            CheckoutItems,
            UpdatedCartItems,
            RadiosInput,
            TextareaInput,
            StripePaymentElement,
        },
        computed: {
//            subtotal() {
//                return 123;
//            }
        },
        watch: {
//            'form.cart_items_by_supplier': {
//                deep: true,
//                handler: function () {
//                    this.updateCheckout();
//                },
//            },
        },
        methods: {
            removeDeliveryAddress() {
                this.form.delivery_address = null;
                this.form.delivery_address_id = null;
            },
            updateCheckout() {
                console.log('Updating checkout...');
                this.$inertia.post(route('checkout.index'), this.form, {preserveScroll: true, preserveState: true});
            }
        },
    }
</script>